export default "__VITE_ASSET__038963fb__"